/**
 * Utility to get detailed plan information (label, colors, dots) based on plan name and status.
 */
export const getPlanDetails = (planName, status) => {
    if (status !== 'active') {
        return {
            label: status === 'past_due' ? 'Past Due' : 'Free Plan',
            colors: 'bg-slate-50 text-slate-400 border-slate-100',
            dot: 'bg-slate-300',
            bg: 'bg-slate-50 border-slate-100 text-slate-400'
        };
    }
    
    // Normalize plan names
    const name = planName || '';
    
    if (name.includes('Professional Monthly') || (!planName && status === 'active')) {
        return {
            label: 'Pro Monthly',
            colors: 'bg-emerald-50 text-emerald-600 border-emerald-100',
            dot: 'bg-emerald-500',
            bg: 'bg-emerald-50 border-emerald-100 text-emerald-700'
        };
    }
    
    if (name.includes('Professional Yearly')) {
        return {
            label: 'Pro Yearly',
            colors: 'bg-blue-50 text-blue-600 border-blue-100',
            dot: 'bg-blue-500',
            bg: 'bg-blue-50 border-blue-100 text-blue-700'
        };
    }
    
    if (name.includes('Standard Monthly')) {
        return {
            label: 'Standard Monthly',
            colors: 'bg-amber-50 text-amber-600 border-amber-100',
            dot: 'bg-amber-500',
            bg: 'bg-amber-50 border-amber-100 text-amber-700'
        };
    }
    
    if (name.includes('Standard Yearly')) {
        return {
            label: 'Standard Yearly',
            colors: 'bg-purple-50 text-purple-600 border-purple-100',
            dot: 'bg-purple-500',
            bg: 'bg-purple-50 border-purple-100 text-purple-700'
        };
    }
    
    // Default fallback for other active statuses
    return {
        label: planName || 'Pro Monthly',
        colors: 'bg-emerald-50 text-emerald-600 border-emerald-100',
        dot: 'bg-emerald-500',
        bg: 'bg-emerald-50 border-emerald-100 text-emerald-700'
    };
};
